import BusinessCenterRoundedIcon from "@mui/icons-material/BusinessCenterRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import FileOpenRoundedIcon from "@mui/icons-material/FileOpenRounded";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import { Box, Button, Chip, Grid, Modal, Paper, TextField, Tooltip, Typography, styled, Divider, FormControlLabel, Checkbox } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useFormik } from "formik";
import * as Yup from 'yup';
import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
import Header from "../components/Header";
import { useLocation } from 'react-router-dom';
import Avatar from "@mui/material/Avatar";
import { decode } from "base-64";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: 'groove',
  border: '3px',
  borderColor: 'grey',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)',
  marginTop: '10px',  
  marginBottom: '10px',
  minHeight: '50px',
  borderRadius: '10px'
}));

const TeamsCard = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  paddingTop: 4,
  paddingBottom: 4,
  borderStyle: 'groove',
  border: '3px',
  borderColor: 'grey',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)',
  marginTop: '10px',  
  marginBottom: '10px',
  minHeight: '50px',
  borderRadius: '10px'
}));

const CreditOfficerDashboard = () => {
    const [loan_data, setLoan_data] = useState([]);
    const [team_data, setTeam_data] = useState([]);
    const [show_one, setShow_one] = useState(false);

    const handleOpenDetails = (row) => {
        setLoan_data(row)
        setShow_one(true)
        formik.setFieldValue('request_id', row.id)
    }

    const getMyData = () => {
        toast.promise(
            api.get("/association/credit/officer/data", {
              headers: {
                Authorization: "Bearer " + fetchToken(),
                "Content-Type": "multipart/form-data",
              },
            }),
            {
              loading: "Loading Your Dashboard",
              success: (response) => {
                setTeam_data(response.data);
                // console.log(response.data)
                
                return "Dashboard Loaded Successfully";
              },
              error: (error) => {
                console.error(error);
                return 'Error, please try again';
              },
            }
          );
    }

    useEffect(() => {
        getMyData();
    },[])
    
  

  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: '90%', sm: '90%', md: 900 },
    maxHeight: "80vh",
    minHeight: "70vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";
    if (day === 1 || day === 21 || day === 31) suffix = "st";
    else if (day === 2 || day === 22) suffix = "nd";
    else if (day === 3 || day === 23) suffix = "rd";
    return `${day}${suffix} ${month} ${year}`;
  }

  const formik = useFormik({
    initialValues: {
      request_id: null,
      amount_recommending: null, 
      note: "",
    },
    onSubmit: (values) => {
      const data = new FormData();
      data.append("id", values.request_id);
      if(values.amount_recommending){
        data.append("recommended_amount", values.amount_recommending);
      }
      data.append("note", values.note);
    
      toast.promise(
          api
          .post(
            "/association/request/recommendation",
            data,
            {
              headers: {
                Authorization: "Bearer " + fetchToken(),
                "Content-Type": "multipart/form-data",
              },
            }
          ),
          {
              loading: 'Processing request...',
              success: (response) => {
                setShow_one(false);
                setLoan_data([]);
                formik.handleReset();
                getMyData();

                return response.data
              },
              error: (error) => {
                  console.log(error);
                  
                  return 'Error, Please try again'
              }
          }
      )
    },
  });


  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 5 }}>
          {/* HEADER */}
          <Box>
            <Typography
              variant="h3"
              sx={{ textAlign: "center", m: 1 }}
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b>My Dashboard</b>
            </Typography>
          </Box>
          {/* Main Content */}
          <Grid container spacing={1}>
            {/* list of things */}
            <Grid item xs={12} md={8}>
                <Item>
                <Typography
                    variant="h5"
                    sx={{ textAlign: "center", m: 1 }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                    <b>Active Requests</b>
                </Typography>

                <Divider variant="middle" sx={{my:4}}>
                    <Typography
                        variant="caption"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                        <b>Groups Loan Requests</b>
                    </Typography>
                </Divider>
                <Box sx={{ display:'flex', flexDirection:'row' }}>
                    <Box sx={{ display:'flex', flexDirection:'row', overflowX: "auto",
                        "&::-webkit-scrollbar": {
                        width: "7px",
                        },
                        "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                        },
                        "&::-webkit-scrollbar-thumb": {
                        background: "#888",
                        borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                        background: "#555",
                    }, }}>
                        {!team_data?.group_loans ? (
                                <Typography
                                    sx={{ m: 1 }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                    <b>No Group Loans Available</b>
                                </Typography>
                                ) : null}
                    {
                        team_data && team_data?.group_loans?.map((item) => (
                            <Box sx={{mx:3}}>
                            <Item>
                                <Box sx={{ display:'flex', flexDirection:'row', justifyContent:'space-between' }}>
                                    <Box sx={{ display:'flex', flexDirection:'column' }}>
                                        <Typography
                                            variant="h5"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                            <b>{item.group_name}</b>
                                        </Typography>
                                        <Typography
                                            variant="caption"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                            <b>Savings Group: {item.association_name}</b>
                                        </Typography>
                                    </Box>
                                    <Box sx={{ px: 5 }}></Box>
                                    <Box>
                                        <Button
                                            size="small"
                                            color="success"
                                            variant="contained"
                                            sx={{
                                                borderRadius: 2,
                                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                "&:hover": {
                                                boxShadow: "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                backgroundColor: "#14213d",
                                                },
                                            }}
                                            onClick={() => handleOpenDetails(item)}
                                        >
                                            <FileOpenRoundedIcon />
                                        </Button>
                                    </Box>
                                </Box>
                            </Item>
                        </Box>
                        ))
                    }
                    </Box>
                </Box>
                <Divider variant="middle">
                    <Typography
                        variant="caption"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                        <b>Individual Loans Requests</b>
                    </Typography>
                </Divider>

                    <Box
                                sx={{
                                overflow: "auto",
                                marginBottom: 10,
                                maxHeight: 340,
                                "&::-webkit-scrollbar": {
                                    width: "7px",
                                    height: "7px",
                                },
                                "&::-webkit-scrollbar-track": {
                                    background: "#f1f1f1",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                    background: "#888",
                                    borderRadius: "10px",
                                },
                                "&::-webkit-scrollbar-thumb:hover": {
                                    background: "#555",
                                },
                                }}
                            >
                                {!team_data?.loans ? (
                                <Typography
                                    sx={{ m: 1 }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                    <b>No Individual Loans Available</b>
                                </Typography>
                                ) : null}

                                <Table size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>No.</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Request Date</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Loan Product</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Amount</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Member</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Savings Group</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Group Name</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    {/* <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Cluster</b>
                                        </Typography>{" "}
                                    </TableCell> */}
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Open</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {team_data?.loans?.map((row, index) => (
                                    <TableRow
                                        key={row.index}
                                        sx={{
                                        "&:last-child td, &:last-child th": {
                                            border: 0,
                                        },
                                        backgroundColor: "#f5f3f4",
                                        }}
                                    >
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{index + 1}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{formatDateToYearMonthDay(new Date(row.transaction_date))}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.account_name}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{currencyFormat.format(row.amount)}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.member_name}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.association_name}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.group_name}</b>
                                        </Typography>
                                        </TableCell>
                                        {/* <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.cluster_name}</b>
                                        </Typography>
                                        </TableCell> */}
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <Button
                                                  size="small"
                                                  color="success"
                                                  variant="contained"
                                                  sx={{
                                                  borderRadius: 2,
                                                  boxShadow:
                                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                  "&:hover": {
                                                      boxShadow:
                                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                      backgroundColor: "#14213d",
                                                  },
                                                  }}
                                                  onClick={() => handleOpenDetails(row)}
                                              >
                                                  <FileOpenRoundedIcon />
                                              </Button>
                                          </Typography>
                                        </TableCell>
                                        
                                    </TableRow>
                                    ))}
                                </TableBody>
                                </Table>
                            </Box>
                </Item>
            </Grid>
            {/* Details Board */}
            <Grid item xs={12} md={4}>
                <Item>
                    <Typography
                        variant="h4"
                        sx={{ textAlign: "center", m: 1 }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                        <b>Loan Details</b>
                    </Typography>
                    {
                        !show_one &&
                            <Typography
                                variant="caption"
                                sx={{ textAlign: "center" }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                                <b>Open Group Or Individual Loan To View Details</b>
                            </Typography>
                    }
                    <Divider variant='middle' sx={{ my:3 }}/>
                    {
                        loan_data.request_type === "Loan"?
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={6}>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Requesting Amount: {currencyFormat.format(loan_data.amount)}</b>
                                    </Typography>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Request Date: {formatDateToYearMonthDay(new Date(loan_data.transaction_date))}</b>
                                    </Typography>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Loan Product: {loan_data.account_name}</b>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Cluster: {loan_data.cluster_name}</b>
                                    </Typography>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Community: {loan_data.community_name}</b>
                                    </Typography>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Savings Group: {loan_data.association_name}</b>
                                    </Typography>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Member Name: {loan_data.member_name}</b>
                                    </Typography>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Member Phone: {loan_data.member_phone}</b>
                                    </Typography>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Passbook No.: {loan_data.passbook}</b>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Divider variant="middle" />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography variant="h4" sx={{ textAlign:'center', m:1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Process Request</b>
                                    </Typography>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>NB: Leave field empty if there is no need to recommend an amount</b>
                                    </Typography>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>NB: Note field is not optional</b>
                                    </Typography>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>NB: If Part Of A Group Request, Make Sure To Process All Individual Requests After Processing Group</b>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        sx={{ m:1 }}
                                        size="small"
                                        name="amount_recommending"
                                        type="number"
                                        inputProps={{ step: 'any' }}
                                        value={formik.values.amount_recommending}
                                        onChange={formik.handleChange}
                                        placeholder="Amount Recommending"
                                        fullWidth
                                    />
                                    <TextField
                                        sx={{ m:1 }}
                                        size="small"
                                        required
                                        name="note"
                                        type='text'
                                        multiline
                                        minRows={4}
                                        value={formik.values.note}
                                        onChange={formik.handleChange}
                                        placeholder="Note here..."
                                        fullWidth
                                    />
                                    
                                    <Box sx={{ display:'flex', flexDirection:'row', mt:'auto' }}>
                                        <Button
                                            size="small"
                                            color="error"
                                            variant="contained"
                                            sx={{
                                            borderRadius: 2,
                                            m: 1,
                                            boxShadow:
                                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                            "&:hover": {
                                                boxShadow:
                                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                backgroundColor: "#14213d",
                                            },
                                            }}
                                            onClick={formik.handleReset}
                                        >
                                            Cancel
                                        </Button>

                                        <Button
                                            size="small"
                                            color="success"
                                            variant="contained"
                                            sx={{
                                            borderRadius: 2,
                                            m: 1,
                                            boxShadow:
                                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                            "&:hover": {
                                                boxShadow:
                                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                backgroundColor: "#14213d",
                                            },
                                            }}
                                            onClick={formik.handleSubmit}
                                        >
                                            Complete
                                        </Button>
                                    </Box>
                                    </Grid>
                            </Grid>
                        : loan_data.request_type === "Group Loan"?
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={6}>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Requesting Amount: {currencyFormat.format(loan_data.total_amount)}</b>
                                    </Typography>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Build Date: {formatDateToYearMonthDay(new Date(loan_data.build_date))}</b>
                                    </Typography>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Loan Product: {loan_data.account_name}</b>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Cluster: {loan_data.cluster_name}</b>
                                    </Typography>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Community: {loan_data.community_name}</b>
                                    </Typography>
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Savings Group: {loan_data.association_name}</b>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Divider variant="middle" />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography variant="h4" sx={{ textAlign:'center', m:1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Process Group Request</b>
                                    </Typography>
                                    <Typography sx={{color:'red'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>NB: First, Make sure All The Group's Individual Requests In The
                                            Table Have been Completely Process Individually
                                        </b>
                                    </Typography>
                                    <Typography sx={{color:'red'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>NB: Make Sure All Requests In Group Is Processed Before Processing This</b>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        sx={{ m:1 }}
                                        size="small"
                                        required
                                        name="note"
                                        type='text'
                                        multiline
                                        minRows={4}
                                        value={formik.values.note}
                                        onChange={formik.handleChange}
                                        placeholder="Note here..."
                                        fullWidth
                                    />
                                    
                                    <Box sx={{ display:'flex', flexDirection:'row', mt:'auto' }}>
                                        <Button
                                            size="small"
                                            color="error"
                                            variant="contained"
                                            sx={{
                                            borderRadius: 2,
                                            m: 1,
                                            boxShadow:
                                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                            "&:hover": {
                                                boxShadow:
                                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                backgroundColor: "#14213d",
                                            },
                                            }}
                                            onClick={formik.handleReset}
                                        >
                                            Cancel
                                        </Button>

                                        <Button
                                            size="small"
                                            color="success"
                                            variant="contained"
                                            sx={{
                                            borderRadius: 2,
                                            m: 1,
                                            boxShadow:
                                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                            "&:hover": {
                                                boxShadow:
                                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                backgroundColor: "#14213d",
                                            },
                                            }}
                                            onClick={formik.handleSubmit}
                                        >
                                            Complete
                                        </Button>
                                    </Box>
                                    </Grid>
                                
                        </Grid>
                        :null
                    }

                </Item>
            </Grid>
          </Grid>
        </Box>
      </main>
    </div>
  );
};

export default CreditOfficerDashboard;